"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var Box = function (props) {
    return React.createElement(Box.Element, __assign({}, props));
};
Box.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* all your css goes here */\n\n  /* you can use variables here like tokens */\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n\n  /* you can use props here to customize the element */\n  width: ", ";\n  height: ", ";\n\n  /* this is how you add pseudo states */\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  /* all your css goes here */\n\n  /* you can use variables here like tokens */\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n\n  /* you can use props here to customize the element */\n  width: ", ";\n  height: ", ";\n\n  /* this is how you add pseudo states */\n  &:hover {\n    background: ", ";\n  }\n"])), tokens_1.colors.base.grayLightest, tokens_1.colors.base.grayDark, tokens_1.misc.radius, function (props) { return (props.big ? '100px' : '50px'); }, function (props) { return (props.big ? '100px' : '50px'); }, tokens_1.colors.base.grayLight);
Box.defaultProps = {
    big: false
};
exports.default = Box;
var templateObject_1;
//# sourceMappingURL=box.js.map